module.exports = __webpack_public_path__ + "static/media/img-0025a19b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/flagler-logo.png
// module id = 5284
// module chunks = 39